export default "__VITE_ASSET__fxL84Dko__"